import {useEffect, useState} from "react";
import Button from "../../../general/Button";
import PriceDisplay from "../../../PriceDisplay";
import ProductSidebarActions from "../../../product/ProductSidebarActions";
import {useRouter} from "next/router";
import ProductsServices from "../../../../services/Products.services";
import ToastService from "../../../../services/Toast.Service";
import SelectImagePopup from "./SelectImagePopup";
import CreateOrSelectQuotationToAddLine from "./CreateOrSelectQuotationToAddLine";
import QuotationServices from "../../../../services/Quotation.services";

export default function AddProductToQuotation({
                                                  jwtToken,
                                                  variant,
                                                  loggedIn,
                                                  userInfo,
                                                  product,
                                                  allImages,
                                                  allowRedirect = true,
                                                  handleCancelAction
                                              }) {

    const [quantity, setQuantity] = useState(null);
    const [noteInputEl, setNoteInputEl] = useState();
    const router = useRouter();
    const [isFavorite, setIsFavorite] = useState(product?.isFavorite);
    const [isDisabled, setIsDisabled] = useState(false);
    const [minimumAmount, setMinimumAmount] = useState(product?.minimum_quantity);
    const [imagePopupActive, setImagePopupActive] = useState(false);
    const [selectQuotationPopupActive, setSelectQuotationPopupActive] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);
    const [longitude, setLongitude] = useState();
    const [latitude, setLatitude] = useState();
    const [location, setLocation] = useState();
    const [localQuote, setLocalQuote] = useState();

    const [replaceLine, setReplaceLine] = useState(null);

    useEffect(() => {
        const stringifiedQuote = localStorage.getItem("quotation");

        if (stringifiedQuote) {
            const cache = JSON.parse(stringifiedQuote);
            setQuantity(cache?.quantity ? cache?.quantity : null);
            setNoteInputEl(cache?.note ? cache?.note : null);
            setReplaceLine(cache?.line ? cache?.line : null);
        }

        setSelectedImage(null);
    }, []);

    const emitSelectedImage = (uid) => {
        setSelectedImage(uid);
    }

    const handleAddToInvoice = (e, offerteID = null) => {

        if (localStorage.getItem("quotation")) {
            let cachedQuote = JSON.parse(localStorage.getItem("quotation"));
            setLocalQuote(cachedQuote);
            offerteID = cachedQuote.uid;
        }

        if (e) {
            e.preventDefault();
        }

        let productQuantityCheck = parseInt(quantity);
        let minimumAmount_check = parseInt(minimumAmount);

        if (productQuantityCheck < minimumAmount_check) {
            const toast = ToastService.loadToast();
            ToastService.errorToast(
                `De hoeveelheid moet minstens ${minimumAmount} zijn!`,
                toast
            );

            return;
        }

        if (allImages?.length > 1 && !selectedImage) {
            setImagePopupActive(true);
            return;
        }

        if (!offerteID) {
            setSelectQuotationPopupActive(true);
            return;
        }

        addQuotationLine(offerteID)
    };

    const addQuotationLine = async (uid) => {

        const line = await QuotationServices.addLineToQuotation(
            jwtToken, uid, quantity, variant?.commerce?.id, noteInputEl, longitude, location, latitude, selectedImage, replaceLine, true
        );

        if (allowRedirect) {
            router.push("/offerte/bewerken/" + uid);
        } else {
            handleCancelAction()
            setImagePopupActive(false);
            setSelectQuotationPopupActive(false);
        }

        if (localStorage.getItem("quotation")) {
            let cachedQuote = JSON.parse(localStorage.getItem("quotation"));
            localStorage.setItem(
                "quotation",
                JSON.stringify({
                    uid: cachedQuote.uid,
                    reference: cachedQuote.reference,
                })
            );
        }
    }

    const createNewQuotation = async (reference) => {

        try {
            // create a new quotation
            const quote = await QuotationServices.createNewQuotation(jwtToken, reference, true)

            // add line to quotation
            const line = await QuotationServices.addLineToQuotation(
                jwtToken, quote.data.uid, quantity, variant?.commerce?.id, noteInputEl, longitude, location, latitude, selectedImage, replaceLine, true
            );

            if (quote && !localStorage.getItem("quotation")) {
                localStorage.setItem(
                    "quotation",
                    JSON.stringify({
                        uid: quote.data.uid,
                        reference: reference,
                    })
                );
            }

            router.push("/offerte/bewerken/" + quote.data.uid);
        } catch (e) {

        }
    }

    const setLonLatLocation = (lon, lat, toast) => {
        if (lon && lat) {
            setLongitude(lon);
            setLatitude(lat);
        }

        if (toast) {
            ToastService.successToast("Locatie ophalen geslaagd", toast);
        }
    };

    const setSetLocation = (location) => {
        if (location) {
            setLocation(location);
        }
    };

    const showFavoriteButton = () => {
        if (loggedIn && userInfo?.role != "ADMIN") {
            return (
                <Button
                    handleClick={(e) => ProductsServices.toggleFavorite(jwtToken, router.query.uid, isFavorite)}
                    text={
                        isFavorite
                            ? "Verwijder uit favorieten"
                            : "Voeg toe aan favorieten"
                    }
                    leftIcon={
                        isFavorite
                            ? "/assets/icon/material-symbols_heart-minus-outline.svg"
                            : "/assets/icon/material-symbols_heart-plus-outline.svg"
                    }
                />
            );
        }
    }

    const variantName = () => {
        return (
            <div className="lg:hidden">
                <p className="font-bold mb-2">Naam</p>
                <div className="space-y-0 text-sm">
                    {variant?.latijnseNaam && (
                        <p>Latijn: {variant?.latijnseNaam}</p>
                    )}
                    <p>Nederlands: {variant?.nederlandseNaam}</p>
                </div>
            </div>)
    }

    const priceDisplay = () => {
        return (
            <>
                <p className="font-bold mb-2">Prijs</p>
                <div>
                    <p>
                    <span className="text-xl font-bold">
                      <PriceDisplay
                          price={variant?.adjusted_price / 100}
                          option={userInfo?.price_display_option}
                      />
                    </span>
                        <span className="text-xs">
                      {loggedIn ? " excl" : " incl"}. BTW per stuk
                    </span>
                    </p>
                </div>
            </>
        )
    }

    const uniqueSellingPoints = () => {
        return (
            <div>
                <ul className="mt-2.5 space-y-2">
                    <li className="flex items-start">
                        <img
                            src="/assets/icon/list-icon-check.svg"
                            alt="List icon"
                            className="mr-2 mt-1"
                        />
                        Vóór donderdag 12:00 uur bestellen is volgende week
                        planten
                    </li>
                    <li className="flex items-start">
                        <img
                            src="/assets/icon/list-icon-check.svg"
                            alt="List icon"
                            className="mr-2 mt-1"
                        />
                        Altijd AA kwaliteit bomen en planten
                    </li>
                    <li className="flex items-start">
                        <img
                            src="/assets/icon/list-icon-check.svg"
                            alt="List icon"
                            className="mr-2 mt-1"
                        />
                        Franco geleverd vanaf € 350,00
                    </li>
                </ul>
            </div>
        )
    }

    return (
        <section className="mt-2.5 lg:col-start-10 lg:col-end-13">
            <div className="olafGrid lg:!olafGrid">
                <div className="flex flex-col">

                    {variantName()}
                    {showFavoriteButton()}
                    {priceDisplay()}

                    <p className="font-bold mb-2">Bestellen</p>
                    <form onSubmit={(e) => handleAddToInvoice(e)}>
                        <div className="flex">
                            <div className="w-1/2 bg-white flex items-center justify-between mr-2 border-b-2 border-olaf-green-700">
                                <div
                                    className="font-bold text-olaf-green-500 cursor-pointer px-4 h-full flex items-center"
                                    onClick={() =>
                                        setQuantity(
                                            quantity > 1
                                                ? quantity - 1
                                                : quantity
                                        )
                                    }
                                >
                                    -
                                </div>
                                <input
                                    type="number"
                                    min="1"
                                    name="productQuantity"
                                    id="productQuantity"
                                    value={quantity}
                                    className="text-center font-bold text-olaf-green-500 w-full outline-none !border-none"
                                    autoFocus
                                    onChange={(e) => {
                                        setQuantity(e.target.value);
                                    }}
                                />
                                <div
                                    className="font-bold text-olaf-green-500 cursor-pointer px-4 h-full flex items-center"
                                    onClick={() =>
                                        quantity
                                            ? setQuantity(
                                                quantity
                                                    ? parseInt(quantity) + 1
                                                    : quantity
                                            )
                                            : setQuantity(1)
                                    }
                                >
                                    +
                                </div>
                            </div>
                            <div className="w-1/2 border-b-2 border-olaf-green-700">
                                <input
                                    type="text"
                                    defaultValue={noteInputEl}
                                    onChange={(e) => {
                                        setNoteInputEl(e.target.value);
                                    }}
                                    placeholder="Notitie"
                                    id="company_name"
                                    className={`bg-white w-full h-full text-sm py-2 px-5 rounded-none outline-none text-olaf-green-700 font-medium appearance-none !border-none`}
                                />
                            </div>
                        </div>
                        <ProductSidebarActions
                            variant={variant}
                            setProductQuantity={setQuantity}
                            setLonLatLocation={setLonLatLocation}
                            setSetLocation={setSetLocation}
                        />
                        {loggedIn ? (
                            <button
                                disabled={isDisabled}
                                className="mt-4 cursor-pointer w-full h-[40px] flex items-center justify-center rounded-tl-[10px] rounded-br-[10px] text-sm font-bold border-2 grow bg-olaf-green-500 text-white border-olaf-green-500 hover:bg-transparent hover:text-olaf-green-500 transition duration-200 ease-in-out"
                            >
                                Toevoegen aan offerte
                            </button>
                        ) : (
                            <Button
                                text="Log in om te bestellen"
                                url={`/inloggen?redirect=${router.asPath}`}
                                style="primary"
                                className="grow mt-4"
                            />
                        )}
                    </form>
                    <div className="mt-2">
                        <p>
                    <span className="text-xl font-bold">
                      <PriceDisplay
                          price={
                              quantity
                                  ? ((variant?.adjusted_price / 100) * quantity)
                                  : 0
                          }
                          option={userInfo?.price_display_option}
                      />
                    </span>
                            <span className="text-xs"> totaal</span>
                        </p>
                    </div>

                    {uniqueSellingPoints()}
                </div>
            </div>

            <SelectImagePopup
                handleCancelAction={() => setImagePopupActive(false)}
                handleAcceptAction={(e) => handleAddToInvoice(e, null)}
                open={imagePopupActive}
                allImages={allImages}
                emitSelectedImage={emitSelectedImage}
                selected={selectedImage}
            />

            <CreateOrSelectQuotationToAddLine
                jwtToken={jwtToken}
                handleCancelAction={() => setSelectQuotationPopupActive(false)}
                handleAcceptAction={() => setSelectQuotationPopupActive(false)}
                open={selectQuotationPopupActive}
                addQuotationLine={addQuotationLine}
                createNewQuotation={createNewQuotation}
            />
        </section>
    );
}